import request from '../utils/request';

export interface Order {
  teamName?: string;
  dietaryRequirements?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  quantity: number;
  total: number;
}

export interface CreateOrderPayload {
  baseId: string;
  date: string;
  payment: {
    token: string;
    verificationToken: string;
  };
  order: Order;
}

export async function createOrder({
  baseId,
  date,
  payment: { token, verificationToken },
  order: { teamName, dietaryRequirements, firstName, lastName, email, phone, quantity, total }
}: CreateOrderPayload) {
  try {
    return request(`/api/order/curry-quiz/${baseId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sourceId: token,
        verificationToken,
        teamName,
        dietaryRequirements,
        firstName,
        lastName,
        email,
        phone,
        quantity,
        total,
        date
      })
    });
  } catch (error) {
    throw new Error(error);
  }
}
